/**
 * @type {Map<string, number>}
 */
const usedIds = new Map();

/**
 * Generate a unique ID.
 *
 * @param {string} [prefix]
 * @returns {string}
 */
export function uniqueId(prefix = '') {
  let key = prefix ? prefix + '-' : prefix;
  let increment = usedIds.get(key) ?? 0;
  usedIds.set(key, ++increment);
  return key + increment;
}

/**
 * @template TReturnValue
 * @param {string} selector
 * @param {(elements: HTMLElement[]) => TReturnValue} callback
 * @param {() => TReturnValue} [fallback]
 * @returns {?TReturnValue}
 */
export function whenFound(selector, callback, fallback = null) {
  const elements = Array.from(document.querySelectorAll(selector));

  if (elements.length === 0) {
    return fallback?.();
  }

  return callback(elements);
};
